import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pruta-logo-white.svg")